/**
 * This hook is A TEMPORARY HOOK TO MANAGE THE AMS360 INTEGRATION SETTINGS FOR SPECIFIC ORGANIZATIONS.
 *
 * This was created to avoid having to create the entire pattern for the integration management configurable on the admin.
 *
 * In a perfect world we would have a way to manage the integration settings for specific organizations.
 */

import * as Api from '@ViewModels';

// TODO: Before going to production, we need to set the correct organization ids in the ENABLED_ORGANIZATION_IDS constant.
const ENABLED_ORGANIZATION_IDS = [
	'bc7b3d90-ca01-4813-871b-9adff6be0d7e', // Dev account for Testing
	'176089a0-9510-42e0-ab25-0954e4bd3f75', // Production account client: Insurance Brokers of Minnesota
];

export const isSpecificOrganizationsManageAms360Enabled = (userSession: Api.UserSessionContext) => {
	if (userSession.user.role !== 'admin' && userSession.user.role !== 'superAdmin') {
		return false;
	}

	return ENABLED_ORGANIZATION_IDS.includes(userSession.account.toJs()?.id);
};
